














































































































































import { Inject, Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import UpdateProjectDialog from "@/custom/page/filemanager/project/UpdateProjectDialog.vue";
import CreateProjectDialog from "@/custom/page/filemanager/project/CreateProjectDialog.vue";
import ProjectService from "@/entities/project/project.service";
import { CREATE_MAP, viewPageToQueryPage } from "@/constants";
import { format, parseISO } from "date-fns";
import ConfirmDialog from "@/custom/page/common/ConfirmDialog.vue";
import { IProject } from "@/shared/model/project.model";

const ALL = 'ALL';
@Component({ components: { ConfirmDialog, UpdateProjectDialog, CreateProjectDialog } })
export default class ProjectListPage extends Vue {
  @Inject() readonly provincesFn;
  @Inject() userAdminDataFn;
  // @Inject() projectsFn;

  projects = [];
  projectLoading = false;

  mounted() {
    this.showAllProject = !!this.hasAdminRole;
    this.fetchProjects();
  }

  projectThumbnailUrl(id: number) {
    return new ProjectService().thumbnail(id);
  }

  headers = [
    // { text: 'ID', value: 'id', width: '3rem' },
    {
      text: '',
      value: 'thumbnail',
      width: '10rem',
      sortable: true,
    },
    {
      text: 'Tên dự án',
      value: 'name',
      width: '10rem',
      sortable: true,
    },
    // { text: 'Mô tả', value: 'description', width: '10rem' },
    {
      text: 'Tỉnh',
      value: 'province',
      width: '8rem',
      sortable: true,
    },
    {
      text: 'Loại dự án',
      value: 'period',
      width: '8rem',
      sortable: true,
    },
    {
      text: 'Kích hoạt',
      value: 'activated',
      width: '8rem',
      sortable: true,
    },
    // { text: 'Nhóm quyền', value: 'roles', width: '12rem' },
    { text: '', value: 'actions', width: '130px', sortable: false },
    { text: 'Người tạo', value: 'createdBy', width: '8rem', sortable: false },
    { text: 'Ngày tạo', value: 'createdDate', width: '10rem', sortable: false },
    { text: 'Người sửa', value: 'lastModifiedBy', width: '8rem', sortable: false },
    { text: 'Ngày sửa', value: 'lastModifiedDate', width: '10rem', sortable: false },
  ];

  customSort(items, index, isDesc) {
    if (index.length === 0) {
      return items;
    }
    const desc = isDesc[0] ? -1 : 1;
    if (index[0] === 'province') {
      items.sort((a, b) => {
        let c = this.provinceMap[a.province.id].name.localeCompare(this.provinceMap[b.province.id].name);
        if (c > 0) return 1 * desc;
        if (c < 0) return -1 * desc;
        return 0;
      });
    } else if (index[0] === 'name') {
      items.sort((a, b) => {
        let c = a.name.localeCompare(b.name);
        if (c > 0) return 1 * desc;
        if (c < 0) return -1 * desc;
        return 0;
      });
    } else if (index[0] === 'period') {
      items.sort((a, b) => {
        let c = a.period - b.period;
        if (c > 0) return -1 * desc;
        if (c < 0) return 1 * desc;
        return 0;
      });
    }
    return items;
  }

  icons = [
    {
      onClick: item => {
        this.editItem(item);
      },
      icon: 'mdi-pencil',
      tooltip: 'Sửa',
      color: 'blue',
      authorities: ['ROLE_ADMIN', 'ROLE_USER'],
    },
    {
      onClick: item => {
        this.deleteProject(item);
      },
      icon: 'mdi-delete',
      tooltip: 'Xóa',
      authorities: ['ROLE_ADMIN'],
    },
    {
      onClick: item => {
        this.$router.push({ name: 'ImportFilePage', params: { projectId: item.id + '' } });
      },
      icon: 'mdi-file-plus-outline',
      tooltip: 'Thêm File',
      color: 'green',
      authorities: ['ROLE_ADMIN', 'ROLE_USER'],
    },
    {
      onClick: item => {
        this.$router.push({ name: 'ProjectFilesDetailFileList', params: { projectId: item.id } });
      },
      icon: 'mdi-text-box-multiple-outline',
      tooltip: 'DS Files',
      authorities: ['ROLE_ADMIN', 'ROLE_USER'],
    },
  ];

  get provincesSelectList() {
    const provinces = this.provincesFn().provinces;
    const provinceMap = CREATE_MAP(provinces);
    return this.addAllSelect(this.projects.map(e => provinceMap[e.province.id]));
  }

  get periodSelectList() {
    return this.addAllSelect(this.projectPeriods);
  }

  showAllProject: boolean = false;

  @Watch('page')
  @Watch('pageSize')
  @Watch('showAllProject')
  async fetchProjects() {
    this.projectLoading = true;
    let projectService = new ProjectService();
    let rs: any;
    if (this.showAllProject) {
      rs = await projectService.filter(viewPageToQueryPage({ page: this.page, size: this.pageSize }), encodeURI(JSON.stringify({})));
    } else {
      rs = await projectService.retrieve(viewPageToQueryPage({ page: this.page, size: this.pageSize }));
    }
    this.projects = rs.data;
    this.projects.sort((a, b) => {
      let c = this.provinceMap[a.province.id].name.localeCompare(this.provinceMap[b.province.id].name);
      if (c > 0) return 1;
      if (c < 0) return -1;
      return 0;
    });
    this.serverItemsSize = parseInt(rs.headers['x-total-count']);
    this.projectLoading = false;
  }

  serverItemsSize = 20;

  addAllSelect(arr = []) {
    return [{ id: ALL, name: 'Tất cả' }, ...arr];
  }

  filter = {
    province: ALL,
    period: ALL,
  };

  page = 1;
  pageSize = 9999;

  get roleMap() {
    return CREATE_MAP(this.userAdminDataFn().roles);
  }

  get provinceMap() {
    return CREATE_MAP(this.provincesFn().provinces);
  }

  get items() {
    let projects = this.projects;
    // console.log(projects);
    if (this.filter.province !== ALL) {
      projects = projects.filter(e => e.province.id === this.filter.province);
    }
    if (this.filter.period !== ALL) {
      projects = projects.filter(e => e.period === this.filter.period);
    }
    const searchString = this.searchValue.toLowerCase();
    return projects.filter(e => {
      return e.name.toLowerCase().includes(searchString) || e.description.toLowerCase().includes(searchString);
    });
  }

  createProjectDialog = {
    open: false,
  };
  updateProjectDialog = {
    open: false,
    data: {},
  };

  editItem(item) {
    this.updateProjectDialog = {
      open: true,
      data: item,
    };
  }

  openCreateProjectDialog() {
    this.createProjectDialog.open = true;
  }

  formatDate(isoDate) {
    if (isoDate == null) {
      return '';
    }
    return format(parseISO(isoDate), 'HH:mm:ss dd/MM/yyyy');
  }

  searchValue = '';

  confirmDialogData = {
    title: '',
    text: '',
    dialog: false,
    onOk: () => undefined,
  };

  projectPeriods = [
    { id: 0, name: 'Khảo sát' },
    { id: 1, name: 'Dự án' },
  ];

  deleteProject(projectItem) {
    this.confirmDialogData.title = 'Xác nhận';
    this.confirmDialogData.text = `Bạn có muốn xóa dự án ${projectItem.name}?`;
    this.confirmDialogData.dialog = true;
    this.confirmDialogData.onOk = async () => {
      let projectService = new ProjectService();
      try {
        await projectService.delete(projectItem.id);
        (this.$root as any).$bvToast.toast(`Đã xóa thành công dự án ${projectItem.name}`, {
          toaster: 'b-toaster-top-center',
          title: 'Thành công',
          variant: 'success',
          solid: true,
          autoHideDelay: 5000,
        });
        await this.fetchProjects();
      } catch (e) {
        (this.$root as any).$bvToast.toast('Có lỗi xảy ra, vui lòng kiểm tra lại', {
          toaster: 'b-toaster-top-center',
          title: 'Có lỗi',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
        });
      } finally {
        this.confirmDialogData.dialog = false;
      }
    };
  }

  public get authenticated(): boolean {
    return this.$store.getters.authenticated;
  }

  public hasAnyAuthority(authorities: any): boolean {
    for (let i = 0; i < authorities.length; i++) {
      if (this.$store.getters.account.authorities.includes(authorities[i])) {
        return true;
      }
    }
    return false;
  }

  updateProjectActivated(project: IProject) {
    let projectService = new ProjectService();
    projectService.partialUpdate({ id: project.id, activated: project.activated }).then(() => {});
  }

  get hasAdminRole() {
    let account = this.$store.getters.account;
    return account.authorities.includes('ROLE_ADMIN');
  }
}
